// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    basePublicGetV1PublicGetAnnouncements (params?: {}): Promise<Dict>;
    v1PublicGetPublicAuth (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetInstruments (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetBook (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetCandlestick (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetTrades (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetTickers (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetValuations (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetExpiredSettlementPrice (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetInsurance (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetAnnouncements (params?: {}): Promise<Dict>;
    v1PublicGetPublicGetRiskParameters (params?: {}): Promise<Dict>;
    v1PublicPostPublicStakingGetConversionRate (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateSetCancelOnDisconnect (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetCancelOnDisconnect (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateUserBalance (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateUserBalanceHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetPositions (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCreateOrder (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateAmendOrder (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCreateOrderList (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCancelOrder (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCancelOrderList (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCancelAllOrders (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateClosePosition (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetOrderHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetOpenOrders (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetOrderDetail (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetTrades (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateChangeAccountLeverage (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetTransactions (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCreateSubaccountTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetSubaccountBalances (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetOrderList (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCreateWithdrawal (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetCurrencyNetworks (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetDepositAddress (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetAccounts (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetWithdrawalHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetDepositHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetFeeRate (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateGetInstrumentFeeRate (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatDepositInfo (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatDepositHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatWithdrawHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatCreateWithdraw (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatTransactionQuota (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatTransactionLimit (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateFiatFiatGetBankAccounts (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingStake (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingUnstake (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetStakingPosition (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetStakingInstruments (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetOpenStake (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetStakeHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetRewardHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingConvert (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetOpenConvert (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateStakingGetConvertHistory (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateCreateIsolatedMarginTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostPrivateChangeIsolatedMarginLeverage (params?: {}): Promise<Dict>;
    v2PublicGetPublicAuth (params?: {}): Promise<Dict>;
    v2PublicGetPublicGetInstruments (params?: {}): Promise<Dict>;
    v2PublicGetPublicGetBook (params?: {}): Promise<Dict>;
    v2PublicGetPublicGetCandlestick (params?: {}): Promise<Dict>;
    v2PublicGetPublicGetTicker (params?: {}): Promise<Dict>;
    v2PublicGetPublicGetTrades (params?: {}): Promise<Dict>;
    v2PublicGetPublicMarginGetTransferCurrencies (params?: {}): Promise<Dict>;
    v2PublicGetPublicMarginGetLoadCurrenices (params?: {}): Promise<Dict>;
    v2PublicGetPublicRespondHeartbeat (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateSetCancelOnDisconnect (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetCancelOnDisconnect (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCreateWithdrawal (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetWithdrawalHistory (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetCurrencyNetworks (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetDepositHistory (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetDepositAddress (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateExportCreateExportRequest (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateExportGetExportRequests (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateExportDownloadExportOutput (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetAccountSummary (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCreateOrder (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCancelOrder (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCancelAllOrders (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCreateOrderList (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetOrderHistory (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetOpenOrders (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetOrderDetail (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetTrades (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetAccounts (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateGetSubaccountBalances (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateCreateSubaccountTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcGetOtcUser (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcGetInstruments (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcRequestQuote (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcAcceptQuote (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcGetQuoteHistory (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcGetTradeHistory (params?: {}): Promise<Dict>;
    v2PrivatePostPrivateOtcCreateOrder (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicAuth (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetInstruments (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetBook (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetCandlestick (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetTrades (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetTickers (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetValuations (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetExpiredSettlementPrice (params?: {}): Promise<Dict>;
    derivativesPublicGetPublicGetInsurance (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateSetCancelOnDisconnect (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetCancelOnDisconnect (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateUserBalance (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateUserBalanceHistory (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetPositions (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCreateOrder (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCreateOrderList (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCancelOrder (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCancelOrderList (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCancelAllOrders (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateClosePosition (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateConvertCollateral (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetOrderHistory (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetOpenOrders (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetOrderDetail (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetTrades (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateChangeAccountLeverage (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetTransactions (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateCreateSubaccountTransfer (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetSubaccountBalances (params?: {}): Promise<Dict>;
    derivativesPrivatePostPrivateGetOrderList (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
